import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { HIGHLIGHT_COLOR } = constants;

let styles = {
  base: {
    display: 'block',
    position: 'relative',
    cursor: 'pointer',
    userSelect: 'none',
    margin: '2px 0',
    width: '100%',
    ':hover input ~ span': {
      borderColor: '#bbb',
      ':after': {
        backgroundColor: '#bbb'
      }
    }
  },
  input: {
    opacity: 0,
    cursor: 'pointer',
    ':checked ~ span:after': {
      display: 'block'
    }
  },
  checkmark: {
    position: 'absolute',
    top: 2,
    left: 0,
    height: 15,
    width: 15,
    backgroundColor: 'transparent',
    border: `1px solid ${HIGHLIGHT_COLOR}`,
    borderRadius: 20,
    ':after': {
      content: '""',
      backgroundColor: HIGHLIGHT_COLOR,
      borderRadius: 10,
      position: 'absolute',
      display: 'none',
      left: 2,
      top: 2,
      width: 11,
      height: 11
    }
  },
  label: {
    fontSize: '1.1em'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/radiobutton/RadioButton.styles.js